<template>
  <div class="tableList">
    <slot name="perfix" v-if="tableData" :data="tableData">
      <!--统计表头-->
    </slot>
    <div class="slider-block" v-if="sliderVal >= 0 && sliderMax > 0">
      <span style="text-align: center; display: block; color: #f60">横向滚动表格</span>
      <el-slider v-model="sliderVal" :show-tooltip="false" :max="sliderMax"/>
    </div>
    <div v-loading="loading" element-loading-text="Loading...">
      <slot v-if="tableData" :data="tableData.data">
        <el-table
          ref="jiemoTableList"
          :data="tableData.data"
          v-on="$listeners"
          v-bind="$attrs"
          stripe
          border
          highlight-current-row
          @header-dragend="headerDragend"
          @sort-change="sortChange"
          @cell-mouse-enter="hoverLog"
          @cell-mouse-leave="leaveLog"
        >
          <slot name="firstColumn" v-if="tableData.data"/>
          <slot
            v-for="(column, key) in tableData.header"
            :name="key"
            :label="typeof column !== 'string' ? column.label : column"
            :attrs="typeof column !== 'string' ? column.attrs : []"
          >
            <el-table-column
              :prop="key"
              :label="typeof column !== 'string' ? column.label : column"
              :key="key"
              v-bind="typeof column !== 'string' ? column.attrs : []"
            >
              <template slot-scope="props">
                <jm-dict-select
                  :show="true"
                  v-if="showDictValue(column)"
                  v-bind="getDictBindValue(column)"
                  v-model="props.row[key]"
                />
                <template v-else>{{ props.row[key] }}</template>
              </template>
            </el-table-column>
          </slot>
          <template slot="empty" v-if="tableData.empty !== ''">{{ tableData.empty }}</template>
          <template name="append">
            <slot name="lastColumn"/>
          </template>
        </el-table>
      </slot>
      <div v-if="tableData && tableData.data" class="flip-area">
        <el-pagination
          v-if="!noPagination && tableData.data.length > 0"
          :current-page.sync="internalCurrentPage"
          :page-size="internalPageSize"
          :page-sizes="pageSizes"
          :layout="layout"
          :total="amount"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import jmDictSelect from '@/components/tool/select/dictSelect.vue';

export function insertEnter(str, n) {
  let len = str.length;
  let strTemp = '';
  if (len > n) {
    strTemp = str.substring(0, n);
    str = str.substring(n, len);
    return `${strTemp} <br /> ${insertEnter(str, n)}`;
  }
  return str;
}

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    searchData: {
      type: Object,
      default() {
        return {};
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    postData: {
      type: Object,
      default() {
        return {};
      }
    },
    refresh: {
      type: [Boolean, Number],
      default: false
    },
    noPagination: {
      type: Boolean,
      default: false
    },
    inited: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default () {
        return [10, 20, 30, 40, 50, 100];
      }
    },
    /**
     * 隐藏操作区域
     */
    hideOptArea: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    modifier: {
      type: Function,
      default: null
    },
    heightNum: {
      type: Number,
      default: 600
    }
  },
  components: { jmDictSelect },
  data() {
    return {
      tableData: {
        data: null,
        header: null,
        has_opt_area: false
      },
      amount: null,
      loading: false,
      searching: false,
      tableFields: {},
      sortData: {},
      sliderVal: 0, // 控制滚动条数值
      sliderMax: 0, // 初始化滚动条最大值
      internalCurrentPage: 1,
      internalPageSize: 10,
      isHover: false,
      countTimer: null
    };
  },

  computed: {
    showOperateArea() {
      if (this.tableData.has_opt_area === false) {
        return false;
      }
      if (this.tableData && this.tableData.data.length === 0) {
        return false;
      }
      return true;
    },
    listRefresh() {
      return this.$store.state.refresh;
    }
  },
  mounted() {
    this.internalPageSize = this.pageSize;
    if (this.pageSizes.length < 1) {
      this.layout = 'total, prev, pager, next, jumper';
    }

    /**
     * 初始化数据
     */
    this.$nextTick(function() {
      this.getTableData();
    });

    /**
     * 大坑，监听window窗口随时变化
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    window.onresize = () => {
      this.calculateScroll();
    };
  },
  methods: {
    /**
     * 方法：clearSelection()
     */
    clearSelection() {
      this.$refs.jiemoTableList.clearSelection();
    },
    showDictValue(column) {
      return (
        column.attrs &&
        (typeof column.attrs.dict_value !== 'undefined' ||
          typeof column.attrs.dict_type !== 'undefined' ||
          typeof column.attrs.dictlist !== 'undefined')
      );
    },
    hoverLog(row, column) {
      if (column.fixed === 'right') {
        this.isHover = true;
        this.$emit('showAllWidth', this.isHover);
      }
    },
    leaveLog(row, column) {
      if (column.fixed === 'right') {
        this.isHover = false;
        this.$emit('showAllWidth', this.isHover);
      }
    },

    /**
     * Dict component bind
     */
    getDictBindValue(column) {
      if (!column.attrs) {
        return {};
      }

      if (column.attrs.dictlist) {
        return { dictlist: column.attrs.dictlist || [] };
      }

      if (column.attrs.dict_type) {
        return {
          type: column.attrs.type,
          dictType: column.attrs.dict_type,
          name: column.attrs.name
        };
      }

      if (column.attrs.dict_value) {
        return { dict: column.attrs.dict_value };
      }
    },

    /**
     * 请求数据实现翻页
     */
    getTableData(
      currentPage = this.internalCurrentPage,
      pageSize = this.internalPageSize,
      amount = this.amount
    ) {
      clearTimeout(this.countTimer);
      this.loading = true;
      this.countTimer = setTimeout(() => {
        this.$http._post({
          url: this.url + (this.noPagination ? '' : `?page=${currentPage}`),
          data: {
            ...this.postData,
            pageSize,
            amount,
            sortData: this.sortData,
            searchData: this.searchData
          }
        }).then(({ data }) => {
          // if (data.data && data.data.length < 1) {
          //   this.theightNum = 110;
          // }
          // if (data.data && data.data.length < 10) {
          //   this.theightNum = 'auto';
          // }
          // if (data.data && data.data.length > 9) {
          //   this.theightNum = 500;
          // }
          this.tableData = data;
          if (this.modifier) {
            this.tableData = this.modifier(this.tableData);
          }
          this.amount = data.total;
          this.$emit('table-list-data', this.tableData.data);
          this.$emit('update:inited', true);
          this.$emit('update:refresh', false);
          this.$emit('update:currentPage', currentPage);
          this.$emit('update:pageSize', pageSize);
          this.internalPageSize = pageSize;
          // console.log(this.$store);
          this.$store.commit('updateRefresh', false);
          this.loading = false;
          this.calculateScroll();
        })
          .catch((data) => {
            if (data.data.code === 4004) {
              setTimeout(() => {
                window.opener = null;
                window.open('', '_self');
                window.close();
              }, 2000);
            }
          });
      }, 100);
    },

    /**
     * pageSize 改变时会触发
     */
    handleSizeChange(size) {
      this.getTableData(this.internalCurrentPage, size);
    },

    /**
     * currentPage 改变时会触发
     */
    handleCurrentChange(currentPage) {
      !this.searching && this.getTableData(currentPage, this.internalPageSize);
    },

    tidyTableFields() {
      Object.keys(this.tableFields).forEach((index) => {
        if (!this.tableData.header[index]) {
          delete this.tableFields[index];
          this.sortData = {};
        }
      });
    },
    headerDragend(newWidth, oldWidth, { property }) {
      this.tidyTableFields();
      Object.entries(this.tableData.header).forEach(([k, v]) => {
        if (this.tableFields[k] && this.tableFields[k] !== true) {
          return true;
        }
        this.tableFields[k] =
          v.attrs && (v.attrs.width || v.attrs['min-width'])
            ? v.attrs.width || v.attrs['min-width']
            : true;
      });

      if (property in this.tableFields) {
        this.tableFields[property] = newWidth;
      }
      let saveVal = [];
      Object.entries(this.tableFields).forEach(([k, v]) => {
        saveVal.push(v === true ? k : `${k}:${v}`);
      });

      const fieldInfo = this.tableData.field_info;
      if (!fieldInfo) {
        return false;
      }
      this.$http
        ._post({
          url: '/index/field_list/save',
          data: {
            fields: saveVal,
            name: fieldInfo.field_name,
            type: 1,
            id: fieldInfo.field_id
          }
        })
        .then(({ data }) => {
          this.tableData.field_info.field_id = data.id;
          this.calculateScroll();
        });
    },
    sortChange({ prop, order }) {
      if (prop && order) {
        this.sortData = { [prop]: order };
      } else {
        this.sortData = null;
      }
      this.getTableData();
    },
    /**
     * Description: 计算滚动条最大值
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    calculateScroll() {
      this.$nextTick(() => {
        setTimeout(() => {
          const wrapper = this.$el.querySelector('.tableList .el-table__body-wrapper');
          if (wrapper) {
            let viewClientWidth = wrapper.clientWidth;
            let viewScrollWidth = wrapper.scrollWidth;
            this.sliderMax = viewScrollWidth - viewClientWidth;
          }
        }, 0);
      });
    },
    doSearch(page = this.currentPage) {
      this.searching = true;
      this.tidyTableFields();
      this.internalCurrentPage = +page;
      this.getTableData(this.internalCurrentPage);
      this.searching = false;
    }
  },
  watch: {
    /*
     * 监听刷新页面列表
     * */
    refresh(val) {
      if (val) {
        this.doSearch();
      }
    },
    /**
     * Description: 大坑，监听滑动模块数值，给滚动条赋值
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    sliderVal(val) {
      if (val) {
        setTimeout(() => {
          if (this.sliderVal !== 0) {
            this.$el.querySelector('.tableList .el-table__body-wrapper').scrollLeft = val;
          } else {
            this.$el.querySelector('.tableList .el-table__body-wrapper').scrollLeft = 0;
          }
        }, 80);
      }
    },
    listRefresh(val) {
      if (val) {
        this.doSearch(val);
      }
    }
  }
};
</script>
<style>
.tableList .el-table th {
  background-color: #01142d;
  height: 20px;
  line-height: 20px;
}

.tableList a {
  color: #056dae;
}

.tableList a:hover {
  color: #55acee;
}

.tableList .el-table--striped .el-table__body tr:nth-child(2n) td {
  background-color: #e2eaf0;
}

.tableList .el-table__footer-wrapper thead div,
.tableList .el-table__header-wrapper thead div,
.tableList .el-table__fixed-header-wrapper thead div {
  background-color: #01142d;
  color: #fff;
}

.flip-area {
  margin: 10px;
  text-align: right;
}

.tableList .el-table__footer-wrapper thead div,
.tableList .el-table__header-wrapper thead div,
.tableList .el-table__fixed-header-wrapper thead div {
  background-color: #01142d;
  color: #fff;
  text-align: center;
}
.flip-area .el-pager li.active {
  background-color: #01142d;
  border-color: #01142d;
}

.tableList .el-button + .el-button {
  margin: 0 3px;
}

.tableList a .el-button {
  margin: 0 2px;
}

.tableList .el-button--primary.el-button a {
  color: #3368fa;
}

.el-table .el-tooltip {
  cursor: pointer;
}
.showAllWidth {
  min-width: 1000px !important;
  background: #f60 !important;
}
.money-end-wrap{
  padding: 20px 0 20px 83px;
  margin-bottom: 30px;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
}
.money-end-wrap b{
  font-size: 20px;
  color: #3368fa;
}

</style>
